import {$} from '../vendors/jquery';

const landingWrapper = {
    init() {
        $(document).on( 'click', '.gf-landing-wrapper', function(){
            $(this).addClass('clicked');
        });
    }
};

export default landingWrapper;
